import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core';
import React from 'react';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Action, Status, RowTable } from './styled';
import { Typography } from '@material-ui/core';
import moment from 'moment';
import styled from 'styled-components';
import useMedia from 'helpers/useMedia';

export default function ResultTable({ exams, onViewResultClick }) {
  const small = useMedia('(max-width: 920px)');
  if (small) {
    return (
      <React.Fragment>
        {exams.map(exam => (
          <SmallRow key={exam.examKey}>
            <span className="date">{moment(exam.endedAt).format('L')}</span>
            <span className="exam_name">{exam.name}</span>
            <span className="status">Published</span>
            <Action bgColor="#1abc9c" variant="">
              <VisibilityIcon style={{ marginLeft: 5 }} />
              <Typography
                onClick={() => onViewResultClick(exam.examKey)}
                style={{ color: 'white' }}
              >
                View Result
              </Typography>
            </Action>
          </SmallRow>
        ))}
      </React.Fragment>
    );
  }
  return (
    <ResultTableTable>
      <TableHead>
        <TableRow>
          <TableCell>
            <RowTable fontWeight="600">Exam Date</RowTable>
          </TableCell>
          <TableCell>
            <RowTable fontWeight="600">Exam Name</RowTable>
          </TableCell>
          <TableCell>
            <RowTable fontWeight="600">Status</RowTable>
          </TableCell>
          <TableCell>
            <RowTable fontWeight="600">Action</RowTable>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {exams.map(exam => (
          <TableRow key={exam.examKey}>
            <TableCell>
              <Status>{moment(exam.endedAt).format('L')}</Status>
            </TableCell>
            <TableCell>
              <Status>{exam.name}</Status>
            </TableCell>
            <TableCell>
              <Status color="#1abc9c">Published</Status>
            </TableCell>
            <TableCell>
              <Action
                bgColor="#1abc9c"
                onClick={() => onViewResultClick(exam.examKey)}
              >
                <VisibilityIcon style={{ marginLeft: 5 }} />
                <Typography style={{ color: 'white' }}>View Result</Typography>
              </Action>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </ResultTableTable>
  );
}

const ResultTableTable = styled(Table)`
  border-radius: 8px;
  background: white;
  box-shadow: #ccca 0 0 20px;
  th,
  td {
    padding-left: 40px;
  }
`;

const SmallRow = styled.div`
  padding: 20px;
  display: flex;
  background: white;
  border-radius: 8px;
  box-shadow: #ccca 0 0 20px;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;
  &:last-child {
    margin-bottom: 40px;
  }
  .date {
    color: #828282;
    line-height: 0.8;
    font-size: 0.8em;
  }
  .exam_name {
    color: black;
    font-weight: 700;
    font-size: 1.5em;
    line-height: 2.5;
  }
  .status {
    color: #1abc9c;
    position: absolute;
    top: 20px;
    right: 20px;
  }
`;
